(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('MusicalPiece', MusicalPiece);

    MusicalPiece.$inject = ['$resource', 'DateUtils'];

    function MusicalPiece ($resource, DateUtils) {
        var resourceUrl =  'api/musical-pieces/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.compositionDate = DateUtils.convertLocalDateFromServer(data.compositionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.compositionDate = DateUtils.convertLocalDateToServer(copy.compositionDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.compositionDate = DateUtils.convertLocalDateToServer(copy.compositionDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
